/** The lines of one Story text with a stable key each: the character offset of the line in the text. Pure. */
export function keyedStoryLines(lines: ReadonlyArray<string>): Array<{ key: string; line: string }> {
  let offset = 0;
  return lines.map((line) => {
    const key = `l${offset}`;
    offset += line.length + 1;
    return { key, line };
  });
}

/**
 * One line of a lyric cut into parts, the "now word" lit (every whole-word match, case-insensitive).
 * Each part is keyed by its character offset: a word can repeat in a line, an offset cannot. Pure.
 */
export function lyricLineParts(
  line: string,
  nowWord: string | null
): Array<{ key: string; text: string; lit: boolean }> {
  const target = nowWord?.trim().toLowerCase() ?? '';
  let offset = 0;
  return line.split(/(\s+)/).map((text) => {
    const key = `w${offset}`;
    offset += text.length;
    const bare = text.replace(/[^\p{L}\p{N}'’-]/gu, '').toLowerCase();
    return { key, text, lit: target !== '' && bare === target };
  });
}
